'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var React = require('react');
var downshift = require('downshift');
var PropTypes = require('prop-types');
var TextInput = require('./TextInput.js');
var FontIcon = require('./FontIcon.js');
var react = require('@linaria/react');
var jsxRuntime = require('react/jsx-runtime');
require('@babel/runtime/helpers/objectWithoutProperties');
require('react-imask');
require('deepmerge');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var _exp = function _exp() {
  return function (_ref) {
    var isOpen = _ref.isOpen;
    return isOpen ? 'block' : 'none';
  };
};
var _exp2 = function _exp2() {
  return function (_ref2) {
    var isOpen = _ref2.isOpen;
    return isOpen ? '0 2px 6px 0 var(--color-secondary-inactive-lighter)' : 'none';
  };
};
var _exp3 = function _exp3() {
  return function (_ref3) {
    var hasError = _ref3.hasError,
      isOpen = _ref3.isOpen;
    if (isOpen) {
      if (hasError) {
        return 'var(--border-width-xSmall) solid var(--color-status-critical-base)';
      }
      return "var(--border-width-xSmall) solid ".concat('var(--color-secondary-action-base)');
    }
    return 'none';
  };
};
var StyledContainer = /*#__PURE__*/react.styled('div')({
  name: "StyledContainer",
  "class": "s1a6ylw0",
  propsAsIs: false,
  vars: {
    "s1a6ylw0-0": [_exp()],
    "s1a6ylw0-1": [_exp2()],
    "s1a6ylw0-2": [_exp3()]
  }
});

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
({
  /** Array of items to be selected from for the component */
  items: PropTypes__default["default"].array.isRequired,
  /** Label to display in the search box */
  label: PropTypes__default["default"].string.isRequired,
  /** Optional name element for the component */
  name: PropTypes__default["default"].string,
  /** Sets which field of the option object holds the label to be viewed and filtered. ex: displayName */
  optionLabel: PropTypes__default["default"].string,
  /** Sets the currently selected item */
  selectedItem: PropTypes__default["default"].any,
  /** Text to be shown under the dropdown search */
  helperText: PropTypes__default["default"].string,
  /** Enables a red asterisk and marks the field as required */
  required: PropTypes__default["default"].bool,
  /** Sets the error condition of the component */
  hasError: PropTypes__default["default"].bool,
  /** Disables the component, preventing the user from interacting with it */
  disabled: PropTypes__default["default"].bool,
  /** Function to be called when an option is selected */
  onChange: PropTypes__default["default"].func,
  /** Function to be called when the user types in the search box */
  onKeyDown: PropTypes__default["default"].func,
  /** Function to be called when the user navigates away from the component */
  onBlur: PropTypes__default["default"].func,
  /** Additional classes to be passed to the component */
  className: PropTypes__default["default"].string
});
var DropDownSearch = function DropDownSearch(_ref) {
  var hasError = _ref.hasError,
    items = _ref.items,
    name = _ref.name,
    label = _ref.label,
    required = _ref.required,
    disabled = _ref.disabled,
    helperText = _ref.helperText,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onKeyDown = _ref.onKeyDown,
    className = _ref.className,
    optionLabel = _ref.optionLabel;
  var _useState = React.useState(items),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    inputItems = _useState2[0],
    setInputItems = _useState2[1];
  React.useEffect(function () {
    setInputItems(items);
  }, [items]);
  var _useCombobox = downshift.useCombobox({
      id: 'dropDownSearch',
      items: inputItems,
      onSelectedItemChange: function onSelectedItemChange(_ref2) {
        var selectedItem = _ref2.selectedItem;
        if (onChange) {
          onChange(selectedItem);
        }
      },
      onInputValueChange: function onInputValueChange(_ref3) {
        var inputValue = _ref3.inputValue;
        if (onKeyDown) {
          onKeyDown(inputValue);
        }
        if (!inputValue) {
          selectItem(null);
        }
        setInputItems(items.filter(function (item) {
          var text = optionLabel ? item[optionLabel] : item;
          return !inputValue || text.toLowerCase().includes(inputValue === null || inputValue === void 0 ? void 0 : inputValue.toLowerCase());
        }));
      },
      itemToString: function itemToString(item) {
        return item ? optionLabel ? item[optionLabel] : item : '';
      }
    }),
    isOpen = _useCombobox.isOpen,
    getToggleButtonProps = _useCombobox.getToggleButtonProps,
    getMenuProps = _useCombobox.getMenuProps,
    getInputProps = _useCombobox.getInputProps,
    getComboboxProps = _useCombobox.getComboboxProps,
    highlightedIndex = _useCombobox.highlightedIndex,
    getItemProps = _useCombobox.getItemProps,
    getLabelProps = _useCombobox.getLabelProps,
    selectedItem = _useCombobox.selectedItem,
    selectItem = _useCombobox.selectItem,
    reset = _useCombobox.reset;
  var handleBlur = function handleBlur(e) {
    if (onBlur && e) {
      onBlur(e);
    }
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Enter') {
      reset();
    }
  };
  var onLIKeyDown = function onLIKeyDown(e) {
    if (e.key === 'Enter') {
      e.currentTarget.click();
    }
  };
  return /*#__PURE__*/jsxRuntime.jsxs(StyledContainer, {
    isOpen: isOpen,
    hasError: hasError !== null && hasError !== void 0 ? hasError : undefined,
    className: className !== null && className !== void 0 ? className : undefined,
    id: "".concat(label, "Container"),
    children: [/*#__PURE__*/jsxRuntime.jsxs("div", _objectSpread(_objectSpread({}, getComboboxProps()), {}, {
      children: [/*#__PURE__*/jsxRuntime.jsx(TextInput["default"], _objectSpread(_objectSpread(_objectSpread({}, getToggleButtonProps()), getInputProps()), {}, {
        labelProps: getLabelProps(),
        label: label,
        name: name,
        id: label,
        onBlur: handleBlur,
        tabIndex: 0,
        helperText: helperText,
        hasError: hasError,
        required: required,
        disabled: disabled,
        className: "dropDownSearchBox",
        onKeyDown: onKeyDown
      })), selectedItem !== null ? /*#__PURE__*/jsxRuntime.jsx("div", {
        role: "button",
        className: "close",
        "data-testid": "close",
        onClick: reset,
        tabIndex: 0,
        onKeyDown: handleKeyDown,
        "aria-label": "close menu",
        "aria-haspopup": "true",
        "aria-expanded": isOpen,
        children: /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "icon-container",
          children: /*#__PURE__*/jsxRuntime.jsx(FontIcon["default"], {
            iconName: "close",
            fontSize: "var(--font-size-xs)",
            padding: "var(--space-xy-xSmall-rem)"
          })
        })
      }) : /*#__PURE__*/jsxRuntime.jsx("div", _objectSpread(_objectSpread({}, getToggleButtonProps()), {}, {
        children: /*#__PURE__*/jsxRuntime.jsx("div", {
          className: "icon-container",
          children: /*#__PURE__*/jsxRuntime.jsx(FontIcon["default"], {
            iconName: "magnifying-glass-search",
            fontSize: "var(--font-size-xs)",
            padding: "var(--space-xy-xSmall-rem)"
          })
        })
      }))]
    })), /*#__PURE__*/jsxRuntime.jsx("ul", _objectSpread(_objectSpread({
      className: "menu"
    }, getMenuProps()), {}, {
      children: isOpen ? !inputItems.length ? /*#__PURE__*/jsxRuntime.jsx("li", {
        children: "No results found"
      }) : inputItems.map(function (item, index) {
        var text = optionLabel ? item[optionLabel] : item;
        return /*#__PURE__*/jsxRuntime.jsx("li", _objectSpread(_objectSpread({
          tabIndex: 0,
          id: "".concat(label, "Li").concat(index),
          onKeyDown: onLIKeyDown
        }, getItemProps({
          item: item,
          index: index
        })), {}, {
          style: {
            backgroundColor: highlightedIndex === index ? 'var(--color-secondary-input-lightest)' : 'inherit'
          },
          children: text
        }), "".concat(text).concat(index));
      }) : null
    }))]
  });
};

exports["default"] = DropDownSearch;
